import { Box, Button, Typography } from '@mui/material';
import logger from 'app/utils/logger';
import React, { ErrorInfo } from 'react';
import { useCustomNavigate } from '../../utils/customHooks/useCustomNavigate';
interface ErrorBoundaryState {
  hasError: boolean;
}
type NavigationFn = (to: string) => void;

export class ErrorBoundary extends React.Component<
  { children?: React.ReactNode; navigation?: NavigationFn },
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };
  search = typeof window !== 'undefined' ? window.location.pathname : '';
  lang = this.search.split('/')[1] || '';

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.log('ERROR:', error);
    logger.log('ERROR INFO:', errorInfo);
  }

  handleNavigateToRegistration = () => {
    if (this.props.navigation) {
      this.props.navigation('register');
    } else if (typeof window !== 'undefined') {
      // fallback if no navigation function provided
      window.location.href = `/${this.lang}/register`;
    }
  };

  handleReload = () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{ mt: 4, mb: 4, display: 'flex', justifyContent: 'center', flexDirection: 'column' }}
        >
          <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
            <img
              src='/images/digital_account/warning_icon.png'
              alt='non working hour'
              width={64}
              height={64}
            />
            <Typography fontSize={28} lineHeight={2} fontWeight={'bold'} align='center'>
              Texniki xəta baş verdi
            </Typography>
            <Typography fontSize={16} lineHeight={1} align='center'>
              Sistemdə nasazlıq yarandı. Zəhmət olmasa yenidən cəhd edin.
            </Typography>
          </Box>
          <Box display={'flex'} gap={1} justifyContent={'center'}>
            <Button
              sx={{ mt: 3, height: 56, width: 277 }}
              color='secondary'
              onClick={this.handleNavigateToRegistration}
            >
              Əsas səhifəyə qayıt
            </Button>
            <Button sx={{ mt: 3, height: 56, width: 277 }} onClick={this.handleReload}>
              Yenidən cəhd et
            </Button>
          </Box>
        </Box>
      );
    }

    return this.props.children ?? null;
  }
}

// Wrapper to allow using the useCustomNavigate hook and still expose a class error boundary
export default function DigitalErrorBoundary({ children }: { children?: React.ReactNode }) {
  const navigate = useCustomNavigate();

  return <ErrorBoundary navigation={navigate}>{children}</ErrorBoundary>;
}
